
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coachee",
      function () {
        return require("private-next-pages/coachee.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coachee"])
      });
    }
  